var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import bind from 'bind-decorator';
import * as React from 'react';
import { useParams } from 'react-router-dom';
import { Main } from './main';
// Lazy load helper for named exports
const lazyImport = (factory, name) => React.lazy(() => factory().then((module) => ({ default: module[name] })));
// Lazy loaded page components
const NotFoundPage = lazyImport(() => import('./404'), 'NotFoundPage');
const AppleCallbackPage = lazyImport(() => import('./apple_callback'), 'AppleCallbackPage');
const CCRegistrationPage = lazyImport(() => import('./cc_registration'), 'CCRegistrationPage');
const GoalMatchingAssessmentPage = lazyImport(() => import('./main_goal_matching_assessment'), 'GoalMatchingAssessmentPage');
const SignupMatchingAssessmentPage = lazyImport(() => import('./main_signup_matching_assessment'), 'SignupMatchingAssessmentPage');
const CheckEmailPage = lazyImport(() => import('./check_email'), 'CheckEmailPage');
const EmailVerificationPage = lazyImport(() => import('./email_verification'), 'EmailVerificationPage');
const FutureUserPage = lazyImport(() => import('./future_user'), 'FutureUserPage');
const LineCallbackPage = lazyImport(() => import('./line_callback'), 'LineCallbackPage');
const LPIframePage = lazyImport(() => import('./lp_iframe'), 'LPIframePage');
const MagazineUnsubscribePage = lazyImport(() => import('./magazine_unsubscribe'), 'MagazineUnsubscribePage');
const ActivityPage = lazyImport(() => import('./main_activity'), 'ActivityPage');
const MissionsPage = lazyImport(() => import('./main_missions'), 'MissionsPage');
const PlaylistCertificatesPage = lazyImport(() => import('./main_playlist_certificates'), 'PlaylistCertificatesPage');
const MainAnnouncementDetail = lazyImport(() => import('./main_announcement_detail'), 'MainAnnouncementDetail');
const MainAnnouncementList = lazyImport(() => import('./main_announcement_list'), 'MainAnnouncementList');
const UnsubscribeConfirmPage = lazyImport(() => import('./main_unsubscribe_confirm'), 'UnsubscribeConfirmPage');
const HomePage = lazyImport(() => import('./main_home'), 'HomePage');
const LessonPage = lazyImport(() => import('./main_lesson'), 'LessonPage');
const LivePage = lazyImport(() => import('./main_live'), 'LivePage');
const LiveSchedulePage = lazyImport(() => import('./main_live_schedule'), 'LiveSchedulePage');
const MegalosLiveCalendarPage = lazyImport(() => import('./main_megalos_live_calendar'), 'MegalosLiveCalendarPage');
const MainNewPlaylist = lazyImport(() => import('./main_new_playlist'), 'MainNewPlaylist');
const PlanChangePage = lazyImport(() => import('./main_plan_change'), 'PlanChangePage');
const PlanChangeUnsubscribeCpPage = lazyImport(() => import('./main_plan_change_unsubscribe_cp'), 'PlanChangeUnsubscribeCpPage');
const OriginalPlaylistPage = lazyImport(() => import('./main_original_playlist'), 'OriginalPlaylistPage');
const ProgramPage = lazyImport(() => import('./main_program'), 'ProgramPage');
const MainSearchPage = lazyImport(() => import('./main_search'), 'MainSearchPage');
const SearchResultPage = lazyImport(() => import('./main_search_result'), 'SearchResultPage');
const MainTrainersTopPage = lazyImport(() => import('./main_trainers_top'), 'MainTrainersTopPage');
const MainInstructorPage = lazyImport(() => import('./main_instructor'), 'MainInstructorPage');
const UnsubscribeCautionPage = lazyImport(() => import('./main_unsubscribe_caution'), 'UnsubscribeCautionPage');
const PasswordResetPage = lazyImport(() => import('./password_reset'), 'PasswordResetPage');
const PasswordResetRequestPage = lazyImport(() => import('./password_reset_request'), 'PasswordResetRequestPage');
const SignInPage = lazyImport(() => import('./signin'), 'SignInPage');
const SignUpPage = lazyImport(() => import('./signup'), 'SignUpPage');
const MainUserSeasonRankHelpLp = lazyImport(() => import('./main_user_season_rank_help_lp'), 'MainUserSeasonRankHelpLp');
const MainInitialGuide = lazyImport(() => import('./main_initial_guide'), 'MainInitialGuide');
const LiveLessonVimeo = lazyImport(() => import('./main_live_lesson_vimeo'), 'LiveLessonVimeo');
const DormantPage = lazyImport(() => import('./main_dormant'), 'DormantPage');
const TwitterCallback = lazyImport(() => import('./twitter_callback'), 'TwitterCallback');
const MainBillysStudio = lazyImport(() => import('./main_billys_studio'), 'MainBillysStudio');
const SettingPage = lazyImport(() => import('./main_setting'), 'SettingPage');
const MaintenancePage = lazyImport(() => import('./main_maintenance'), 'MaintenancePage');
const CoursePage = lazyImport(() => import('./main_course'), 'CoursePage');
const CourseVolumePage = lazyImport(() => import('./main_course_volume'), 'CourseVolumePage');
const AmazonPayCallback = lazyImport(() => import('./amazon_pay_callback'), 'AmazonPayCallback');
const AmazonPayForSignupCallback = lazyImport(() => import('./amazon_pay_for_signup_callback'), 'AmazonPayForSignupCallback');
const MainPrograms = lazyImport(() => import('./main_programs'), 'MainPrograms');
const MainPlaylists = lazyImport(() => import('./main_playlists'), 'MainPlaylists');
const PlaylistDetail = lazyImport(() => import('./main_playlist_detail'), 'PlaylistDetail');
const MainMyLesson = lazyImport(() => import('./main_my_lesson'), 'MainMyLesson');
const MainInitialGuideDetail = lazyImport(() => import('./main_initial_guide_detail'), 'MainInitialGuideDetail');
const DailyTasksPage = lazyImport(() => import('./main_daily_tasks'), 'DailyTasksPage');
const AndroidAccountDeletion = lazyImport(() => import('./android_account_deletion'), 'AndroidAccountDeletion');
const CoachingPlanUnsubscribePage = lazyImport(() => import('./main_coaching_plan_unsubscribe'), 'CoachingPlanUnsubscribePage');
const MainRankingPage = lazyImport(() => import('./main_ranking'), 'MainRankingPage');
const LeagueLeaderboardPage = lazyImport(() => import('./main_league_leaderboard'), 'LeagueLeaderboardPage');
const CountLessonPage = lazyImport(() => import('./main_count_lesson'), 'CountLessonPage');
const CountLessonDetailPage = lazyImport(() => import('./main_count_lesson_detail'), 'CountLessonDetailPage');
const MainMerchandisePage = lazyImport(() => import('./main_merchandise'), 'MainMerchandisePage');
const CoachingPage = lazyImport(() => import('./main_coaching'), 'CoachingPage');
const DailyTaskSubtaskPage = lazyImport(() => import('./main_daily_task_subtask'), 'DailyTaskSubtaskPage');
const NutrientPage = lazyImport(() => import('./nutrient_page'), 'NutrientPage');
const MealScorePage = lazyImport(() => import('./meal_score_page'), 'MealScorePage');
const ChartTasks = lazyImport(() => import('./main_chart_tasks'), 'ChartTasks');
const InvitationPage = lazyImport(() => import('./main_invitation'), 'InvitationPage');
const SignUpV2Page = lazyImport(() => import('./signup_v2'), 'SignUpV2Page');
const TvLoginPage = lazyImport(() => import('./tv_login_page'), 'TvLoginPage');
/**
 * PageComponentのProvider
 */
export class PageProvider {
    constructor(contentFactory, domainFactory, router, alertPresenter, config) {
        Object.defineProperty(this, "config", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "mainContentFactory", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "domainFactory", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "router", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "alertPresenter", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.mainContentFactory = contentFactory;
        this.domainFactory = domainFactory;
        this.router = router;
        this.alertPresenter = alertPresenter;
        this.config = config;
    }
    /**
     * @returns @type {Main} のJSXElement
     */
    Main() {
        const contentFactory = this.mainContentFactory;
        return (React.createElement(Main, { contentFactory: contentFactory, tracker: this.domainFactory.Tracker(), accountService: this.domainFactory.AccountService(), announcementService: this.domainFactory.AnnouncementService(), alertPresenter: this.alertPresenter, apiClient: this.domainFactory.apiClient, config: this.domainFactory.config }));
    }
    /**
     * @returns @type {Maintenance} のJSXElement
     */
    Maintenance() {
        return React.createElement(MaintenancePage, { apiClient: this.domainFactory.apiClient });
    }
    /**
     * @returns @type {CCRegistrationPage} のJSXElement
     */
    PaymentRegistratoin() {
        return (React.createElement(CCRegistrationPage, { accountService: this.domainFactory.AccountService(), apiClient: this.domainFactory.apiClient, alertPresenter: this.alertPresenter, config: this.config, tagClient: this.domainFactory.tagClient, adlocateClient: this.domainFactory.adlocateClient, adTrackClient: this.domainFactory.adTrackClient, tracker: this.domainFactory.Tracker() }));
    }
    LineCallback() {
        return (React.createElement(LineCallbackPage, { accountService: this.domainFactory.AccountService(), lineClient: this.domainFactory.lineClient, abTestService: this.domainFactory.ABTestService(), router: this.router, config: this.config, tracker: this.domainFactory.Tracker() }));
    }
    AppleCallback() {
        return (React.createElement(AppleCallbackPage, { accountService: this.domainFactory.AccountService(), router: this.router, alertPresenter: this.alertPresenter, tracker: this.domainFactory.Tracker() }));
    }
    AmazonPayCallback() {
        return (React.createElement(AmazonPayCallback, { apiClient: this.domainFactory.apiClient, accountService: this.domainFactory.AccountService(), signedCookieService: this.domainFactory.SignedCookieService(), tracker: this.domainFactory.Tracker(), adlocateClient: this.domainFactory.adlocateClient, adTrackClient: this.domainFactory.adTrackClient, ntaClient: this.domainFactory.ntaClient }));
    }
    AmazonPayForSignupCallback() {
        return (React.createElement(AmazonPayForSignupCallback, { accountService: this.domainFactory.AccountService(), tracker: this.domainFactory.Tracker(), alertPresenter: this.alertPresenter }));
    }
    /**
     * @returns @type {SignUpPage} のJSXElement
     */
    SignUp() {
        return (React.createElement(SignUpPage, { accountService: this.domainFactory.AccountService(), apiClient: this.domainFactory.apiClient, tracker: this.domainFactory.Tracker(), router: this.router, alertPresenter: this.alertPresenter, config: this.config, adlocateClient: this.domainFactory.adlocateClient, tagClient: this.domainFactory.tagClient, lineClient: this.domainFactory.lineClient, gaClient: this.domainFactory.gaClient }));
    }
    /**
     * @returns @type {SignUpV2Page} のJSXElement
     */
    SignUpV2() {
        return (React.createElement(SignUpV2Page, { accountService: this.domainFactory.AccountService(), apiClient: this.domainFactory.apiClient, config: this.config, tracker: this.domainFactory.Tracker(), router: this.router, alertPresenter: this.alertPresenter, adlocateClient: this.domainFactory.adlocateClient, adTrackClient: this.domainFactory.adTrackClient, ntaClient: this.domainFactory.ntaClient, tagClient: this.domainFactory.tagClient }));
    }
    /**
     * @returns @type {SignInPage} のJSXElement
     */
    SignIn() {
        return (React.createElement(SignInPage, { accountService: this.domainFactory.AccountService(), abTestService: this.domainFactory.ABTestService(), alertPresenter: this.alertPresenter, router: this.router, config: this.config, tagClient: this.domainFactory.tagClient, lineClient: this.domainFactory.lineClient, tracker: this.domainFactory.Tracker() }));
    }
    /**
     * @returns @type {EmailVerificationPage} のJSXElement
     */
    EmailVerification() {
        return (React.createElement(EmailVerificationPage, { accountService: this.domainFactory.AccountService(), apiClient: this.domainFactory.apiClient, router: this.router, alertPresenter: this.alertPresenter }));
    }
    /**
     * @returns @type {PasswordResetRequestPage} のJSXElement
     */
    PasswordResetRequestPage() {
        return React.createElement(PasswordResetRequestPage, { apiClient: this.domainFactory.apiClient, alertPresenter: this.alertPresenter });
    }
    /**
     * @returns @type {PasswordResetPage} のJSXElement
     */
    PasswordResetPage() {
        return (React.createElement(PasswordResetPage, { apiClient: this.domainFactory.apiClient, router: this.router, alertPresenter: this.alertPresenter }));
    }
    MagazineUnsubscribePage() {
        const params = useParams();
        return (React.createElement(MagazineUnsubscribePage, { token: params.token, apiClient: this.domainFactory.apiClient, router: this.router }));
    }
    LPIframePage() {
        return React.createElement(LPIframePage, { accountService: this.domainFactory.AccountService(), config: this.config });
    }
    TvLoginPage() {
        return (React.createElement(TvLoginPage, { apiClient: this.domainFactory.apiClient, accountService: this.domainFactory.AccountService(), alertPresenter: this.domainFactory.alertPresenter }));
    }
    SignupMatchingAssessmentPage() {
        return (React.createElement(SignupMatchingAssessmentPage, { apiClient: this.domainFactory.apiClient, config: this.config, accountService: this.domainFactory.AccountService(), tracker: this.domainFactory.Tracker() }));
    }
}
__decorate([
    bind
], PageProvider.prototype, "Main", null);
__decorate([
    bind
], PageProvider.prototype, "Maintenance", null);
__decorate([
    bind
], PageProvider.prototype, "PaymentRegistratoin", null);
__decorate([
    bind
], PageProvider.prototype, "LineCallback", null);
__decorate([
    bind
], PageProvider.prototype, "AppleCallback", null);
__decorate([
    bind
], PageProvider.prototype, "AmazonPayCallback", null);
__decorate([
    bind
], PageProvider.prototype, "AmazonPayForSignupCallback", null);
__decorate([
    bind
], PageProvider.prototype, "SignUp", null);
__decorate([
    bind
], PageProvider.prototype, "SignUpV2", null);
__decorate([
    bind
], PageProvider.prototype, "SignIn", null);
__decorate([
    bind
], PageProvider.prototype, "EmailVerification", null);
__decorate([
    bind
], PageProvider.prototype, "PasswordResetRequestPage", null);
__decorate([
    bind
], PageProvider.prototype, "PasswordResetPage", null);
__decorate([
    bind
], PageProvider.prototype, "MagazineUnsubscribePage", null);
__decorate([
    bind
], PageProvider.prototype, "LPIframePage", null);
__decorate([
    bind
], PageProvider.prototype, "TvLoginPage", null);
__decorate([
    bind
], PageProvider.prototype, "SignupMatchingAssessmentPage", null);
/**
 * MainContent component内でswitchされるページのProvider
 */
export class MainContentProvider {
    constructor(domainFactory, alertPresenter, router, config) {
        Object.defineProperty(this, "router", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "alertPresenter", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "domainFactory", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "config", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "MainCoursePage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ({ profile }) => {
                return (React.createElement(CoursePage, { config: this.config, apiClient: this.domainFactory.apiClient, tracker: this.domainFactory.tracker, profile: profile }));
            }
        });
        Object.defineProperty(this, "MainCourseVolumePage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ({ profile }) => {
                const params = useParams();
                return (React.createElement(CourseVolumePage, { config: this.config, apiClient: this.domainFactory.apiClient, tracker: this.domainFactory.tracker, profile: profile, volumeID: parseInt(params.id) }));
            }
        });
        Object.defineProperty(this, "UnsubscribeCautionPage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ({ profile }) => {
                return (React.createElement(UnsubscribeCautionPage, { accountService: this.domainFactory.AccountService(), alertPresenter: this.alertPresenter, apiClient: this.domainFactory.apiClient, tracker: this.domainFactory.Tracker(), config: this.config, profile: profile }));
            }
        });
        Object.defineProperty(this, "TopPage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ({ profile, setProfile, me, setMe, currentStreak, isTvBannerVisible, onCloseTvBanner, }) => {
                return (React.createElement(HomePage, { apiClient: this.domainFactory.apiClient, twitterService: this.domainFactory.TwitterService(), accountService: this.domainFactory.AccountService(), tracker: this.domainFactory.Tracker(), config: this.config, profile: profile, setProfile: setProfile, me: me, setMe: setMe, currentStreak: currentStreak, isTvBannerVisible: isTvBannerVisible, onCloseTvBanner: onCloseTvBanner }));
            }
        });
        Object.defineProperty(this, "SettingPage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ({ profile, setProfile }) => {
                return (React.createElement(SettingPage, { accountService: this.domainFactory.AccountService(), apiClient: this.domainFactory.apiClient, alertPresenter: this.domainFactory.alertPresenter, config: this.config, tracker: this.domainFactory.Tracker(), profile: profile, setProfile: setProfile }));
            }
        });
        Object.defineProperty(this, "GoalMatchingAssessmentPage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ({ setProfile }) => {
                return (React.createElement(GoalMatchingAssessmentPage, { apiClient: this.domainFactory.apiClient, config: this.config, setProfile: setProfile }));
            }
        });
        Object.defineProperty(this, "DailyTasksPage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ({ profile, setProfile }) => {
                const params = useParams();
                return (React.createElement(DailyTasksPage, { apiClient: this.domainFactory.apiClient, config: this.config, taskName: params.taskName, profile: profile, setProfile: setProfile }));
            }
        });
        Object.defineProperty(this, "DailyTaskSubtaskPage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const params = useParams();
                return (React.createElement(DailyTaskSubtaskPage, { apiClient: this.domainFactory.apiClient, taskName: params.taskName, subtaskName: params.subtaskName, config: this.config }));
            }
        });
        Object.defineProperty(this, "ChartTasksPage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const params = useParams();
                return (React.createElement(ChartTasks, { apiClient: this.domainFactory.apiClient, taskName: params.taskName, chartType: params.chartType }));
            }
        });
        Object.defineProperty(this, "CoachingPage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ({ me, setMe }) => {
                return (React.createElement(CoachingPage, { accountService: this.domainFactory.AccountService(), alertPresenter: this.domainFactory.alertPresenter, apiClient: this.domainFactory.apiClient, tracker: this.domainFactory.Tracker(), me: me, setMe: setMe }));
            }
        });
        this.domainFactory = domainFactory;
        this.alertPresenter = alertPresenter;
        this.router = router;
        this.config = config;
    }
    SearchResultPage() {
        return (React.createElement(SearchResultPage, { apiClient: this.domainFactory.apiClient, tracker: this.domainFactory.Tracker(), config: this.config }));
    }
    MainTrainersTopPage() {
        return React.createElement(MainTrainersTopPage, { apiClient: this.domainFactory.apiClient, router: this.router });
    }
    MainInstructorPage() {
        const params = useParams();
        return React.createElement(MainInstructorPage, { apiClient: this.domainFactory.apiClient, instructorID: parseInt(params.id) });
    }
    ActivityPage() {
        return (React.createElement(ActivityPage, { accountService: this.domainFactory.AccountService(), apiClient: this.domainFactory.apiClient, twitterService: this.domainFactory.TwitterService() }));
    }
    MissionsPage() {
        return React.createElement(MissionsPage, { apiClient: this.domainFactory.apiClient });
    }
    PlaylistCertificatesPage() {
        return (React.createElement(PlaylistCertificatesPage, { apiClient: this.domainFactory.apiClient, twitterService: this.domainFactory.TwitterService() }));
    }
    /**
     * 検索ページ
     */
    MainSearchPage() {
        return (React.createElement(MainSearchPage, { apiClient: this.domainFactory.apiClient, config: this.config, tracker: this.domainFactory.Tracker() }));
    }
    /**
     * ピックアップ商品ページ
     */
    MainMerchandisePage() {
        return React.createElement(MainMerchandisePage, { apiClient: this.domainFactory.apiClient, tracker: this.domainFactory.Tracker() });
    }
    /**
     * ランキングページ
     */
    MainRankingPage() {
        return React.createElement(MainRankingPage, { apiClient: this.domainFactory.apiClient });
    }
    /**
     * リーグのリーダーボードページ
     */
    LeagueLeaderboardPage() {
        return React.createElement(LeagueLeaderboardPage, { apiClient: this.domainFactory.apiClient });
    }
    /**
     * カウントレッスンのコーチ選択ページ
     */
    CountLessonPage() {
        return React.createElement(CountLessonPage, { apiClient: this.domainFactory.apiClient });
    }
    /**
     * カウントレッスンの再生ページ
     */
    CountLessonDetailPage() {
        const params = useParams();
        return React.createElement(CountLessonDetailPage, { apiClient: this.domainFactory.apiClient, countLessonId: Number(params.id) });
    }
    /**
     * プログラムページ
     */
    ProgramPage() {
        const params = useParams();
        return (React.createElement(ProgramPage, { slug: params.slug, lessonService: this.domainFactory.LessonService(), signedCookieService: this.domainFactory.SignedCookieService(), tracker: this.domainFactory.Tracker(), apiClient: this.domainFactory.apiClient, router: this.router, twitterService: this.domainFactory.TwitterService() }));
    }
    /**
     * レッスンページ
     */
    LessonPage() {
        const params = useParams();
        return (React.createElement(LessonPage, { slug: params.slug, type: params.type, lessonService: this.domainFactory.LessonService(), signedCookieService: this.domainFactory.SignedCookieService(), router: this.router, tracker: this.domainFactory.Tracker(), apiClient: this.domainFactory.apiClient, config: this.config, twitterService: this.domainFactory.TwitterService() }));
    }
    InvitationPage() {
        return (React.createElement(InvitationPage, { apiClient: this.domainFactory.apiClient, tracker: this.domainFactory.Tracker(), alertPresenter: this.alertPresenter, config: this.config, accountService: this.domainFactory.AccountService() }));
    }
    PlanChangePage() {
        return (React.createElement(PlanChangePage, { accountService: this.domainFactory.AccountService(), apiClient: this.domainFactory.apiClient, tracker: this.domainFactory.Tracker(), alertPresenter: this.alertPresenter }));
    }
    PlanChangeUnsubscribeCpPage() {
        return (React.createElement(PlanChangeUnsubscribeCpPage, { accountService: this.domainFactory.AccountService(), apiClient: this.domainFactory.apiClient, tracker: this.domainFactory.Tracker(), alertPresenter: this.alertPresenter }));
    }
    CoachingPlanUnsubscribePage() {
        return (React.createElement(CoachingPlanUnsubscribePage, { apiClient: this.domainFactory.apiClient, accountService: this.domainFactory.AccountService(), alertPresenter: this.alertPresenter }));
    }
    UnsubscribeConfirmPage() {
        return (React.createElement(UnsubscribeConfirmPage, { accountService: this.domainFactory.AccountService(), alertPresenter: this.alertPresenter }));
    }
    NotFoundPage() {
        return React.createElement(NotFoundPage, { accountService: this.domainFactory.AccountService() });
    }
    CheckEmailPage() {
        return React.createElement(CheckEmailPage, { accountService: this.domainFactory.AccountService() });
    }
    MegalosLiveCalendar() {
        return (React.createElement(MegalosLiveCalendarPage, { accountService: this.domainFactory.AccountService(), router: this.router, alertPresenter: this.alertPresenter }));
    }
    LiveSchedulePage() {
        return React.createElement(LiveSchedulePage, { apiClient: this.domainFactory.apiClient, tracker: this.domainFactory.Tracker() });
    }
    LivePage() {
        const params = useParams();
        return (React.createElement(LivePage, { id: parseInt(params.id), accountService: this.domainFactory.AccountService(), apiClient: this.domainFactory.apiClient, tracker: this.domainFactory.Tracker(), config: this.config, signedCookieService: this.domainFactory.SignedCookieService() }));
    }
    FutureUserPage() {
        return React.createElement(FutureUserPage, { accountService: this.domainFactory.AccountService() });
    }
    /**
     * オリジナルプレイリストページ
     */
    OriginalPlaylistPage() {
        const params = useParams();
        return (React.createElement(OriginalPlaylistPage, { id: params.id, tracker: this.domainFactory.Tracker(), apiClient: this.domainFactory.apiClient, router: this.router, twitterService: this.domainFactory.TwitterService() }));
    }
    /**
     * お知らせ一覧
     */
    AnnouncementListPage() {
        return (React.createElement(MainAnnouncementList, { announcementService: this.domainFactory.AnnouncementService(), accountService: this.domainFactory.AccountService(), apiClient: this.domainFactory.apiClient }));
    }
    /**
     * お知らせ詳細
     */
    AnnouncementDetailPage() {
        const params = useParams();
        return (React.createElement(MainAnnouncementDetail, { id: parseInt(params.id), apiClient: this.domainFactory.apiClient, accountService: this.domainFactory.AccountService() }));
    }
    /**
     * プレイリスト作成
     */
    NewPlaylistPage() {
        const params = useParams();
        return (React.createElement(MainNewPlaylist, { id: parseInt(params.id), accountService: this.domainFactory.AccountService(), apiClient: this.domainFactory.apiClient, router: this.router, alertPresenter: this.alertPresenter, tracker: this.domainFactory.Tracker() }));
    }
    UserSeassonRankHelpPage() {
        return React.createElement(MainUserSeasonRankHelpLp, { apiClient: this.domainFactory.apiClient, config: this.config });
    }
    InitialGuidePage() {
        return React.createElement(MainInitialGuide, null);
    }
    InitialGuideDetailPage() {
        return React.createElement(MainInitialGuideDetail, null);
    }
    LiveLessonVimeoPage() {
        const params = useParams();
        return (React.createElement(LiveLessonVimeo, { id: parseInt(params.id), accountService: this.domainFactory.AccountService(), apiClient: this.domainFactory.apiClient, tracker: this.domainFactory.Tracker(), signedCookieService: this.domainFactory.SignedCookieService() }));
    }
    DormantPage() {
        return (React.createElement(DormantPage, { apiClient: this.domainFactory.apiClient, accountService: this.domainFactory.AccountService(), alertPresenter: this.alertPresenter, tracker: this.domainFactory.Tracker() }));
    }
    TwitterCallbackPage() {
        return React.createElement(TwitterCallback, { twitterService: this.domainFactory.TwitterService() });
    }
    BillysStudioPage() {
        return React.createElement(MainBillysStudio, { apiClient: this.domainFactory.apiClient });
    }
    MyLessonPage() {
        return (React.createElement(MainMyLesson, { apiClient: this.domainFactory.apiClient, tracker: this.domainFactory.Tracker(), config: this.config }));
    }
    ProgramsPage() {
        return React.createElement(MainPrograms, { apiClient: this.domainFactory.apiClient });
    }
    PlaylistsPage() {
        return React.createElement(MainPlaylists, { apiClient: this.domainFactory.apiClient });
    }
    PlaylistPage() {
        const params = useParams();
        return (React.createElement(PlaylistDetail, { id: Number(params.id), lessonService: this.domainFactory.LessonService(), signedCookieService: this.domainFactory.SignedCookieService(), tracker: this.domainFactory.Tracker(), apiClient: this.domainFactory.apiClient, router: this.router, twitterService: this.domainFactory.TwitterService(), config: this.config }));
    }
    AndroidAccountDeletionPage() {
        return (React.createElement(AndroidAccountDeletion, { accountService: this.domainFactory.AccountService(), tracker: this.domainFactory.Tracker() }));
    }
    NutrientPage() {
        return React.createElement(NutrientPage, { config: this.config, apiClient: this.domainFactory.apiClient });
    }
    MealScorePage() {
        return React.createElement(MealScorePage, { apiClient: this.domainFactory.apiClient });
    }
}
__decorate([
    bind
], MainContentProvider.prototype, "SearchResultPage", null);
__decorate([
    bind
], MainContentProvider.prototype, "MainTrainersTopPage", null);
__decorate([
    bind
], MainContentProvider.prototype, "MainInstructorPage", null);
__decorate([
    bind
], MainContentProvider.prototype, "ActivityPage", null);
__decorate([
    bind
], MainContentProvider.prototype, "MissionsPage", null);
__decorate([
    bind
], MainContentProvider.prototype, "PlaylistCertificatesPage", null);
__decorate([
    bind
], MainContentProvider.prototype, "MainSearchPage", null);
__decorate([
    bind
], MainContentProvider.prototype, "MainMerchandisePage", null);
__decorate([
    bind
], MainContentProvider.prototype, "MainRankingPage", null);
__decorate([
    bind
], MainContentProvider.prototype, "LeagueLeaderboardPage", null);
__decorate([
    bind
], MainContentProvider.prototype, "CountLessonPage", null);
__decorate([
    bind
], MainContentProvider.prototype, "CountLessonDetailPage", null);
__decorate([
    bind
], MainContentProvider.prototype, "ProgramPage", null);
__decorate([
    bind
], MainContentProvider.prototype, "LessonPage", null);
__decorate([
    bind
], MainContentProvider.prototype, "InvitationPage", null);
__decorate([
    bind
], MainContentProvider.prototype, "PlanChangePage", null);
__decorate([
    bind
], MainContentProvider.prototype, "PlanChangeUnsubscribeCpPage", null);
__decorate([
    bind
], MainContentProvider.prototype, "CoachingPlanUnsubscribePage", null);
__decorate([
    bind
], MainContentProvider.prototype, "UnsubscribeConfirmPage", null);
__decorate([
    bind
], MainContentProvider.prototype, "NotFoundPage", null);
__decorate([
    bind
], MainContentProvider.prototype, "CheckEmailPage", null);
__decorate([
    bind
], MainContentProvider.prototype, "MegalosLiveCalendar", null);
__decorate([
    bind
], MainContentProvider.prototype, "LiveSchedulePage", null);
__decorate([
    bind
], MainContentProvider.prototype, "LivePage", null);
__decorate([
    bind
], MainContentProvider.prototype, "FutureUserPage", null);
__decorate([
    bind
], MainContentProvider.prototype, "OriginalPlaylistPage", null);
__decorate([
    bind
], MainContentProvider.prototype, "AnnouncementListPage", null);
__decorate([
    bind
], MainContentProvider.prototype, "AnnouncementDetailPage", null);
__decorate([
    bind
], MainContentProvider.prototype, "NewPlaylistPage", null);
__decorate([
    bind
], MainContentProvider.prototype, "UserSeassonRankHelpPage", null);
__decorate([
    bind
], MainContentProvider.prototype, "InitialGuidePage", null);
__decorate([
    bind
], MainContentProvider.prototype, "InitialGuideDetailPage", null);
__decorate([
    bind
], MainContentProvider.prototype, "LiveLessonVimeoPage", null);
__decorate([
    bind
], MainContentProvider.prototype, "DormantPage", null);
__decorate([
    bind
], MainContentProvider.prototype, "TwitterCallbackPage", null);
__decorate([
    bind
], MainContentProvider.prototype, "BillysStudioPage", null);
__decorate([
    bind
], MainContentProvider.prototype, "MyLessonPage", null);
__decorate([
    bind
], MainContentProvider.prototype, "ProgramsPage", null);
__decorate([
    bind
], MainContentProvider.prototype, "PlaylistsPage", null);
__decorate([
    bind
], MainContentProvider.prototype, "PlaylistPage", null);
__decorate([
    bind
], MainContentProvider.prototype, "AndroidAccountDeletionPage", null);
__decorate([
    bind
], MainContentProvider.prototype, "NutrientPage", null);
__decorate([
    bind
], MainContentProvider.prototype, "MealScorePage", null);
